"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Exported from figma
const SelectArrow = () => /*#__PURE__*/_react.default.createElement("svg", {
  width: "16",
  height: "10",
  viewBox: "0 0 16 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.74329 9.17412C8.34605 9.6155 7.65395 9.6155 7.25671 9.17412L0.502069 1.66897C-0.0771011 1.02544 0.379591 0 1.24536 0H14.7546C15.6204 0 16.0771 1.02544 15.4979 1.66896L8.74329 9.17412Z",
  fill: "#C2C8CE"
}));

var _default = SelectArrow;
exports.default = _default;